export const replaceAll = (input) => {
    if (!input)
        return;
    else
        return input.toLowerCase().replace(/[^\w]/g, '_');
}
